/** Entry provenance. Kept free of zod so the web bundle doesn't pull in the validation library. */
export const ENTRY_SOURCES = [
  'search',
  'recent',
  'favorite',
  'custom',
  'ai_text',
  'ai_photo',
  'ai_label',
  'barcode',
  'usual',
  'copy',
  'what_fits',
  'quick',
  'import',
  /** Added by the server: one day's copy of a daily food (server/recurring.ts). */
  'recurring',
  /** Logged from a recipe: its own page, or the Log sheet's recipe rows (My foods, and Search before you type). */
  'recipe',
] as const;

export type EntrySource = (typeof ENTRY_SOURCES)[number];

export const AI_SOURCES: ReadonlySet<EntrySource> = new Set(['ai_text', 'ai_photo', 'ai_label', 'what_fits']);

/** Logged with AI, or a daily food's copy of an AI estimate (copies keep the AI's confidence). */
export function loggedWithAI(entry: { source: EntrySource; confidence: number | null }): boolean {
  return AI_SOURCES.has(entry.source) || (entry.source === 'recurring' && entry.confidence !== null);
}
